import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListRoles,
    createRole,
    deleteRole,
    updateRoleById,
    getListActions,
    getListActionByRoleId,
} from '../../services/apis/RoleAPIServices'
import { message } from 'antd'

function* saga_getRoleOfUser(action) {
    try {
        const { rid } = action.payload

        const request = yield call(getListActionByRoleId, rid)
        console.log('data role of user', request.data)
        if (request.error.code === 200) {
            yield put(actions.action.getCurrentRoleOfUserDone(request.data))
        }
    } catch (ex) {
        console.log('Load list roles of user error : ', ex.message)
    }
}

function* saga_LoadListRoles(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(state => state.qbrole.pageIndex)
        let page_size = yield select(state => state.qbrole.pageSize)

        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size

        const response = yield call(getListRoles, page_number, page_size)

        if (response.error.code === 200) {
            let total = response.total
            let roles = response.data

            if (roles.length > page_size) roles = roles.slice(0, page_size)

            yield put(actions.action.loadListRolesSuccess(roles))
            yield put(
                actions.action.updateState({
                    total,
                })
            )
        } else {
            console.log(
                'Load list roles call API Errors : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Load list roles error : ', ex.message)
    }
}

function* saga_SaveCurrentRole() {
    try {
        let currentRole = yield select(state => state.qbrole.currentRole)

        let response = ''
        if (currentRole.role_id === 0) {
            response = yield call(createRole, currentRole)
        } else {
            response = yield call(
                updateRoleById,
                currentRole.role_id,
                currentRole
            )
        }

        if (response.error.code === 200) {
            if (currentRole.role_id === 0)
                message.success('Thêm role thành công')
            else message.success('Cập nhật role thành công')

            yield put(actions.action.loadListRoles({}))
        }
        if (response.error.code === 305) {
            message.error('Quyền này đã tồn tại')
        } else {
            console.log(
                'Save current role call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.log('Save current role error :  ', ex.message)
    }
}

function* saga_DeleteRole(action) {
    try {
        const { roleId } = action.payload
        const response = yield call(deleteRole, roleId)

        if (response.error.code === 200) {
            message.success('Xoá role thành công')
            yield put(actions.action.loadListRoles({}))
        } else {
            console.log('Delete role call API error : ', response.error.message)
        }
    } catch (ex) {
        console.log('Delete role error : ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(
            actions.action.loadListRoles({ page_size: pageSize, pageIndex: 1 })
        )
    } catch (ex) {
        console.log('Change page size role error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListRoles({ page_number: pageIndex }))
    } catch (ex) {
        console.log('Change current role page error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_ROLE, saga_LoadListRoles)
    yield takeEvery(actions.type.SAVE_CURRENT_ROLE, saga_SaveCurrentRole)
    yield takeEvery(actions.type.DELETE_ROLE, saga_DeleteRole)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(actions.type.GET_CURRENT_ROLE_USER, saga_getRoleOfUser)
}

export default function* qbroleSaga() {
    yield all([fork(listen)])
}
